import { defineStore } from "pinia";

export const useErrorStore = defineStore({
  id: "errors",
  state: () => ({
    errorMessage: "",
    successMessage: "",
    _errorTimeout: null,
    _successTimeout: null,
  }),
  actions: {
    _normalizeMessage(mess) {
      if (mess == null) return "";
      // Jeśli to Error
      if (mess instanceof Error) return mess.message || String(mess);
      // Jeśli obiekt z typowym polem 'message' lub 'error'
      if (typeof mess === "object") {
        const fromField = mess.message || mess.error || mess.msg;
        if (typeof fromField === "string") return fromField;
        try {
          return JSON.stringify(mess);
        } catch {
          return String(mess);
        }
      }
      // Inne typy
      return String(mess);
    },

    showSuccessMessage(mess) {
      this.clearErrorMessage();
      this.successMessage = this._normalizeMessage(mess);

      clearTimeout(this._successTimeout);
      this._successTimeout = setTimeout(() => {
        this.clearSuccessMessage();
      }, 10000);
    },

    clearSuccessMessage() {
      this.successMessage = "";
      clearTimeout(this._successTimeout);
      this._successTimeout = null;
    },

    showErrorMessage(mess) {
      this.clearSuccessMessage();
      const text = this._normalizeMessage(mess)
        // jeśli chcesz zdejmować prefiks "Error:" (opcjonalnie)
        .replace(/^null:\s*/i, "");
      this.errorMessage = text;

      clearTimeout(this._errorTimeout);
      this._errorTimeout = setTimeout(() => {
        this.clearErrorMessage();
      }, 10000);
    },

    clearErrorMessage() {
      this.errorMessage = "";
      clearTimeout(this._errorTimeout);
      this._errorTimeout = null;
    },
  },
});
